import { createSelector } from "reselect";

export const getOngoingSDPProducts = state => state.smartDP.accommodationsList;
export const getSDPProductsPageSize = state => state.smartDP.accommodationsPageSize;
export const getSDPQuotationItems = state => state.smartDP.quotationItems;
export const getSDPFlights = state => state.smartDP.flights;
export const getActiveSort = state => state.smartDP.sortedBy;
export const getSortUpdated = state => state.smartDP.sortUpdated;
export const getRecommendedSortActivated = state => state.smartDP.recommendedSortActivated;

export const calculateSDPBasePrice = createSelector(
	[getSDPQuotationItems],
	(quotationItems = []) => {
		let total = 0;

		quotationItems.forEach(quotationItem => {
			total += quotationItem.price;
		});

		return total;
	}
);
